import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import './ATCButton.scss';

const ATCButton = ({
  variant,
  cartItems,
  onAdd,
  onUpdate,
  disabled,
}) => {
  const variantId = variant.id;
  const lineItem = useMemo(() => {
    return cartItems.find(li => li.variant.id === variantId); 
  }, [cartItems, variantId]);
  const quantityInCart = lineItem?.quantity ?? 0;
  const [ localQuantityInCart, setLocalQuantityInCart ] = useState(quantityInCart);
  const timeoutRef = useRef(null);
  const subtext = variant.title;
  const quantityAvailable = variant.quantityAvailable;
  const quantityRemaining = Math.max(0, quantityAvailable - localQuantityInCart);

  const increment = useCallback(() => {
    setLocalQuantityInCart(ps => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        const n = Math.min(quantityAvailable, ps + 1);
        lineItem ? onUpdate(lineItem.id, n) : onAdd(variantId, n);
      }, 300);
      return ps + 1;
    });
  }, [onAdd, onUpdate, lineItem, variantId, quantityAvailable]);

  const decrement = useCallback(() => {
    setLocalQuantityInCart(ps => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        const n = Math.max(0, ps - 1);
        lineItem ? onUpdate(lineItem.id, n) : onAdd(variantId, n);
      }, 300);
      return Math.max(0, ps - 1);
    });
  }, [onAdd, onUpdate, lineItem, variantId]);

  // Keeping localQuantityInCart synced with quantityInCart
  useEffect(() => {
    setLocalQuantityInCart(quantityInCart);
  }, [quantityInCart]);

  return (
    <div className={cn({
      'ATCButton': true,
      'ATCButton--disabled': disabled,
    })}>
      {quantityAvailable > 0 && quantityInCart > 0 && (
        <button
          className={cn({
            'ATCButton__QtyCtrl': true,
            'ATCButton__QtyCtrl--sub': true,
            'ATCButton__QtyCtrl--sold-out': quantityRemaining <= 0,
          })}
          onClick={decrement}
          disabled={disabled || localQuantityInCart <= 0}
          children="-"
        />
      )}
      <button className="ATCButton__Main" disabled={disabled || quantityRemaining <= 0} onClick={increment}>
        <span className="ATCButton__Text">
          {quantityRemaining === 0 
            ? localQuantityInCart === 0
              ? 'Sold Out'
              : `Sold Out (${localQuantityInCart})`
            : (localQuantityInCart > 0 || quantityInCart > 0)
              ? `Meal Added (${localQuantityInCart})`
              : 'Add Meal'}
        </span>
        {!subtext.startsWith('Default Title') && <span className="ATCButton__Subtext">{subtext}</span>}
      </button>
      {quantityAvailable > 0 && quantityInCart > 0 && (
        <button
          className={cn({
            'ATCButton__QtyCtrl': true,
            'ATCButton__QtyCtrl--add': true,
            'ATCButton__QtyCtrl--sold-out': quantityRemaining <= 0,
          })}
          onClick={increment}
          disabled={disabled || quantityRemaining <= 0}
          children="+"
        />
      )}
    </div>
  )
}

export default memo(ATCButton);